<div class="d-flex flex-column justify-content-center" style="height: 100%;">
  <span>{{ expenseId }}</span>
  @if (isRecalledExpense) {
    <span class="d-block lH-12 color-red">
      <i class="fas fa-reply-all"></i> {{ 'rolled_back_expense' | translate }}
    </span>
  }
</div>
